module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./CustomerInfoView.js"));
	}, "CustomerInfoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CustomerInfoView!./src/pages/Shop/Visitor/CustomerInfo/CustomerInfoView.js
// module id = 1814
// module chunks = 367